var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-form__tips-area"},[_c('p',{staticClass:"weui-form__tips"},[(_vm.tipContent)?[_vm._v(_vm._s(_vm.tipContent))]:[_vm._t("tipContent")]],2),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }